import Nullstack from 'nullstack';
export default function IconGenderTrasvesti({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-trasvesti",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z"
  }), "   ", Nullstack.element("path", {
    d: "M6 6l5.4 5.4"
  }), "   ", Nullstack.element("path", {
    d: "M4 8l4 -4"
  }), " ");
}